export class HttpError {
    errorMessage?:string;
}